// App.js
import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";

import Navbar from "./Navigation/Navbar";
import Home from "./Pages/Home";
import Projects from "./Pages/Projects";
import Resume from "./Pages/Resume";
import Footer from "./Navigation/Footer";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "./App.css";
import "./index.css";

function App() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem("theme");

    if (savedTheme) {
      return savedTheme === "dark";
    }

    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  useEffect(() => {
    document.documentElement.classList.toggle("dark", isDarkMode);
    localStorage.setItem("theme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  return (
    <div
      data-app-shell="true"
      data-theme={isDarkMode ? "dark" : "light"}
      className="min-h-screen bg-[#f8fafc] text-[#213448] transition-colors duration-300 dark:bg-[#0f172a] dark:text-slate-100"
    >
      {/* fixed top nav */}
      <Navbar
        isDarkMode={isDarkMode}
        onToggleDarkMode={() => setIsDarkMode((current) => !current)}
      />

      {/* center container: sidebar + content */}
      <div className="max-w-5xl mx-auto px-4 pt-20 flex">
        {/* ─── Main Content ─── */}
        <main className="flex-1 pl-8 space-y-32">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/resume" element={<Resume />} />
          </Routes>
          <Footer />
        </main>
      </div>
    </div>
  );
}

export default App;
